import { render, staticRenderFns } from "./TheSideImageConfiguration.vue?vue&type=template&id=233ed739&scoped=true"
import script from "./TheSideImageConfiguration.vue?vue&type=script&lang=js"
export * from "./TheSideImageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TheSideImageConfiguration.vue?vue&type=style&index=0&id=233ed739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ed739",
  null
  
)

export default component.exports